import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleAirPlaySecurityProfilePresetsService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import {
  AirplaySecurityProfileApiActions,
  AirplaySecurityProfileResolverActions,
} from './airplay-security-profile.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class AirplaySecurityProfileEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: AppleAirPlaySecurityProfilePresetsService
  ) {}

  loadSettingsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AirplaySecurityProfileResolverActions.profilesRequested),
      mergeMap(() =>
        safeMap(
          this.api.getAirPlaySecurityPresets('2.0'),
          (profiles) => AirplaySecurityProfileApiActions.profilesLoaded({ profiles }),
          (error) => AirplaySecurityProfileApiActions.profilesLoadedError({ error })
        )
      )
    );
  });
}
